export const DEFAULT_REPLACEMENT_FEE = '50';
export const DEFAULT_CURRENCY = 'AED';

export const LOST_SIM_CARD_ERROR = 'SIM Card is not assigned!';
export const SIM_ADDON_REQUEST_ERROR =
  'Selected Employee does not have a CUG Number!';
